import React, { useState, Fragment } from "react";
import { useQueryClient } from 'react-query';
import { makeStyles } from "@material-ui/core/styles";
import {Grid, Icon, Tooltip} from "@material-ui/core";
import moment from "moment";

import { useAircraftMovements } from "../../../../services/aircraft";
import { useAirports } from "../../../../services/airports";
import MovementsTooltipStyles from "../../styles/MovementsTooltipStyles";

const AirportData = (props) => {
  const queryClient = useQueryClient();

  const airport = useAirports({queryClient, extraKeys:[props.airportCode], useCache: true});

  return (<div style={props.style}>{airport.data?airport.data[0][props.field]:props.airportCode}</div>)
}

const Movements = (props) => {
  const { movement, data } = props;

  const classes = makeStyles(MovementsTooltipStyles)();

  let ctd = [moment.utc(data.ctd).format('DD MMM'), moment.utc(data.ctd).format('HH:mm') ];
  let cta = [moment.utc(data.cta).format('DD MMM'), moment.utc(data.cta).format('HH:mm') ];
  let std = [moment.utc(data.std).format('DD MMM'), moment.utc(data.std).format('HH:mm') ];
  let sta = [moment.utc(data.sta).format('DD MMM'), moment.utc(data.sta).format('HH:mm') ];
  let etd = ["",""];
  let bloff = ["",""];
  let takeoff = ["",""];
  let eta = ["",""];
  let ldg = ["",""];
  let blon = ["",""];

  if (data.etd) {
    etd = [moment.utc(data.etd).format('DD MMM'), moment.utc(data.etd).format('HH:mm') ];
  }
  if (data.eta) {
    eta = [moment.utc(data.eta).format('DD MMM'), moment.utc(data.eta).format('HH:mm') ];
  }

  if (data.bloff) {
    bloff = [moment.utc(data.bloff).format('DD MMM'), moment.utc(data.bloff).format('HH:mm') ];
  }
  if (data.takeoff) {
    takeoff = [moment.utc(data.takeoff).format('DD MMM'), moment.utc(data.takeoff).format('HH:mm') ];
  }
  if (data.eta) {
    eta = [moment.utc(data.eta).format('DD MMM'), moment.utc(data.eta).format('HH:mm') ];
  }
  if (data.ldg) {
    ldg = [moment.utc(data.ldg).format('DD MMM'), moment.utc(data.ldg).format('HH:mm') ];
  }
  if (data.blon) {
    blon = [moment.utc(data.blon).format('DD MMM'), moment.utc(data.blon).format('HH:mm') ];
  }

  if (movement) {
    if (movement.etaUTC) {
      eta = [moment.utc(movement.etaUTC).format('DD MMM'), moment.utc(movement.etaUTC).format('HH:mm') ];
    }
    if (movement.offBlocksTimeUTC) {
      bloff = [moment.utc(movement.offBlocksTimeUTC).format('DD MMM'), moment.utc(movement.offBlocksTimeUTC).format('HH:mm') ];
    }  
    if (movement.takeOffTimeUTC) {
      takeoff = [moment.utc(movement.takeOffTimeUTC).format('DD MMM'), moment.utc(movement.takeOffTimeUTC).format('HH:mm') ];
    }  
    if (movement.landingTimeUTC) {
      ldg = [moment.utc(movement.landingTimeUTC).format('DD MMM'), moment.utc(movement.landingTimeUTC).format('HH:mm') ];
    }  
    if (movement.onBlocksTimeUTC) {
      blon = [moment.utc(movement.onBlocksTimeUTC).format('DD MMM'), moment.utc(movement.onBlocksTimeUTC).format('HH:mm') ];
    }  
  }

  const movementTimes = (
    <Fragment>
      <Grid 
        container direction="row"
        justifyContent="space-between"
      >
        {props.showContracted?
        <Grid item  nowrap="true" key="CTD">
          <div class={classes.timeBlock}>
            <div class={classes.header}>CTD</div>
            <div class={classes.date}>{ctd[0]}</div>
            <div class={classes.time}>{ctd[1]}</div>
          </div>
        </Grid> : null}
        {props.showScheduled?
        <Grid item  nowrap="true" key="STD">
          <div class={classes.timeBlock}>
            <div class={classes.header}>STD</div>
            <div class={classes.date}>{std[0]}</div>
            <div class={classes.time}>{std[1]}</div>
          </div>
        </Grid> : null}
        <Grid item  nowrap="true" key="ETD">
          <div class={classes.timeBlock}>
            <div class={classes.header}>ETD</div>
            <div class={classes.date}>{etd[0]}</div>
            <div class={classes.time}>{etd[1]}</div>
          </div>
        </Grid>
        <Grid item  nowrap="true" key="BLOFF">
          <div class={classes.timeBlock}>
            <div class={classes.header}>BLOFF</div>
            <div class={classes.date}>{bloff[0]}</div>
            <div class={classes.time}>{bloff[1]}</div>
          </div>
        </Grid>
        <Grid item  nowrap="true" key="TO">
          <div class={classes.timeBlock}>
            <div class={classes.header}>T/O</div>
            <div class={classes.date}>{takeoff[0]}</div>
            <div class={classes.time}>{takeoff[1]}</div>
          </div>
        </Grid>
        {props.showContracted?
        <Grid item  nowrap="true" key="CTA">
          <div class={classes.timeBlock}>
            <div class={classes.header}>CTA</div>
            <div class={classes.date}>{cta[0]}</div>
            <div class={classes.time}>{cta[1]}</div>
          </div>
        </Grid> : null}
        {props.showScheduled?
        <Grid item  nowrap="true" key="STA">
          <div class={classes.timeBlock}>
            <div class={classes.header}>STA</div>
            <div class={classes.date}>{sta[0]}</div>
            <div class={classes.time}>{sta[1]}</div>
          </div>
        </Grid> : null}
        <Grid item  nowrap="true" key="ETA">
          <div class={classes.timeBlock}>
            <div class={classes.header}>ETA</div>
            <div class={classes.date}>{eta[0]}</div>
            <div class={classes.time}>{eta[1]}</div>
          </div>
        </Grid>
        <Grid item  nowrap="true" key="LDG">
          <div class={classes.timeBlock}>
            <div class={classes.header}>LDG</div>
            <div class={classes.date}>{ldg[0]}</div>
            <div class={classes.time}>{ldg[1]}</div>
          </div>
        </Grid>
        <Grid item  nowrap="true" key="BLON">
          <div class={classes.timeBlock}>
            <div class={classes.header}>BLON</div>
            <div class={classes.date}>{blon[0]}</div>
            <div class={classes.time}>{blon[1]}</div>
          </div>
        </Grid>
      </Grid>
    </Fragment>
  )

  return movementTimes;
}

const MovementTimes = (props) => {
  const {data} = props;

  const queryClient = useQueryClient();
  //pass a dummy key so hits to cache will return dummy record until rendering tooltip
  const movements = useAircraftMovements({ queryClient, extraKeys: [data.aircraftMovementUuid===null?"dummy":data.aircraftMovementUuid], useCache: data.aircraftMovementUuid===null });

  let movement = null;
  if (movements.data && Array.isArray(movements.data) && movements.data.length > 0) {
    movement = movements.data[0];
  } else {
    // if (movements.isLoading) {
    //   return "Retrieving info...";
    // }
    // if (movements.error) {
    //   return "Error Retrieving Data";
    // }
    // return null;
  }

  return <Movements data={data} movement={movement} showScheduled={props.showScheduled} showContracted={props.showContracted} />
} 

const MovementsTooltip = (props) => {
  const {tripLeg} = props;

  const [load, setLoad] = useState("WAIT");
  // const queryClient = useQueryClient();
  // //pass a dummy key so hits to cache will return dummy record until rendering tooltip
  // const movements = useAircraftMovements({ queryClient, extraKeys: [load==="WAIT"?"dummy":aircraftMovementUuid], useCache: load });

  const classes = makeStyles(MovementsTooltipStyles)();

  let toolTipText = "Retrieving info...";

  const loadData = () => {
    if (load === "WAIT") {
      setLoad("DONE");
    }
  }

  if (load === 'DONE') {
  // if (movements.error) {
  //   toolTipText = "Error Retrieving info...";
  // } 
  // let row = null;
  // if (movements.data && Array.isArray(movements.data) && movements.data.length > 0) {
  //   row = movements.data[0];
  // }
    const data = {
      aircraftMovementUuid: tripLeg.aircraftMovementUuid,
      ctd: tripLeg.contractedDepartureTimeUTC,
      std: tripLeg.scheduledDepartureTimeUTC,
      etd: tripLeg.estimatedDepartureTimeUTC,
      cta: tripLeg.contractedArrivalTimeUTC,
      sta: tripLeg.scheduledArrivalTimeUTC,
      eta: tripLeg.estimatedArrivalTimeUTC,
    }

    toolTipText = (
      <Fragment>
        <div style={{width: "100%"}}>
          <div style={{textAlign: "center", fontWeight: 1000, padding: 5 }}>Flight Movements</div>
          <div style={{ padding: 10, textAlign: "center"}}>
            <div style={{width: 100, display: "inline-block", border: "2px solid #ffffff", textAlign: "center"}}>
              <div style={{fontSize: 20, fontWeight: "bold", padding: 8}}>{tripLeg.originAirportCode}</div>
              <div style={{fontSize: 18, fontWeight: "bold", padding: 6}}><AirportData airportCode={tripLeg.originAirportCode} field='icaoCode'/></div>
              <div style={{fontSize: 14, fontWeight: "bold", padding: 6}}>{moment.utc(tripLeg.scheduledDepartureTimeUTC).format('DD MMM HH:mm')}</div>
            </div>
            <div style={{verticalAlign: "top", padding: "30px 15px", display: "inline-block"}}>
              <div style={{transform: "rotate(90deg)"}}><Icon>flight</Icon></div>
            </div>
            <div style={{width: 100, display: "inline-block", border: "2px solid #ffffff", textAlign: "center"}}>
              <div style={{fontSize: 20, fontWeight: "bold", padding: 8}}>{tripLeg.destinationAirportCode}</div>
              <div style={{fontSize: 18, fontWeight: "bold", padding: 6}}><AirportData airportCode={tripLeg.destinationAirportCode} field='icaoCode'/></div>
              <div style={{fontSize: 14, fontWeight: "bold", padding: 6}}>{moment.utc(tripLeg.scheduledArrivalTimeUTC).format('DD MMM HH:mm')}</div>
            </div>
          </div>
          <MovementTimes data={data} showContracted={props.showContracted} showScheduled={props.showScheduled}/>
        </div>
      </Fragment >
    );
  }

  return (
    <Tooltip onOpen={loadData}
      classes={{ tooltip: props.showContracted && props.showScheduled ? classes.movementTooltipLarge : (props.showContracted || props.showScheduled) ? classes.movementTooltipMedium : classes.movementTooltip }} 
      placement="top-start"
      title={toolTipText}
    >
      {props.children}
    </Tooltip>
  );
}

export {
  MovementsTooltip as default, 
  MovementTimes,
  Movements
};
